module.exports = __webpack_public_path__ + "img/jisusaiche_icon.5cd00f95.png";